import React, { useCallback, useState } from "react";
import { Tabs } from "antd";
import { PlusOutlined, UnorderedListOutlined } from "@ant-design/icons";
import EventForm from "./EventForm";
import EventList from "./EventList";

function EventManagement() {
  const [activeTab, setActiveTab] = useState("list");
  const [editingEvent, setEditingEvent] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleCreated = useCallback(() => {
    setRefreshKey((k) => k + 1);
    setActiveTab("list");
  }, []);

  const handleEdit = useCallback((event) => {
    setEditingEvent(event);
    setActiveTab("form");
  }, []);

  const handleUpdated = useCallback(() => {
    setEditingEvent(null);
    setRefreshKey((k) => k + 1);
    setActiveTab("list");
  }, []);

  const handleCancelEdit = useCallback(() => {
    setEditingEvent(null);
    setActiveTab("list");
  }, []);

  const tabItems = [
    {
      key: "list",
      label: (
        <span>
          <UnorderedListOutlined />
          Events
        </span>
      ),
      children: (
        <EventList
          refreshKey={refreshKey}
          onEdit={handleEdit}
          onRefresh={handleCreated}
        />
      ),
    },
    {
      key: "form",
      label: (
        <span>
          <PlusOutlined />
          {editingEvent ? "Edit Event" : "Create Event"}
        </span>
      ),
      children: (
        <EventForm
          editingEvent={editingEvent}
          onCreated={handleCreated}
          onUpdated={handleUpdated}
          onCancel={handleCancelEdit}
        />
      ),
    },
  ];

  return (
    <Tabs
      activeKey={activeTab}
      onChange={(key) => {
        if (key !== "form") setEditingEvent(null);
        setActiveTab(key);
      }}
      items={tabItems}
    />
  );
}

export default EventManagement;
